import React from 'react';
import { useTranslation } from 'react-i18next';
export var GenericFooter = function () {
    var t = useTranslation().t;
    return (React.createElement("p", { className: "m-0 mt-1 text-sm font-normal text-gray-500" }, t('feedbackModal.generic.question.footer', 'Do not enter personally identifiable information, e.g. Name.')));
};
